module.exports = __webpack_public_path__ + "static/media/file-text.14946014.svg";